/**
 * Constants used for Next fetch cache length parameters.
 *
 * See https://nextjs.org/docs/14/app/api-reference/functions/fetch
 */
export enum CacheLength {
	NO_CACHE = 0,
	SHORT = 600,
	LONG = 3600,
}
